export enum UserTypeEnum {
  Athlete = 1,
  Stakeholder = 2,
  General = 3,
}
